(function () {
  if (window.AbacusAnimations) {
    window.AbacusAnimations.init();
    return;
  }

  const preview = new URLSearchParams(window.location.search).get("preview");

  function applyPreviewMode() {
    if (!preview) return;
    document.body.classList.add("ab-preview-mode");
    document.querySelectorAll("[data-section]").forEach((section) => {
      section.classList.toggle("is-preview-target", section.dataset.section === preview);
    });
  }

  function setupTabs() {
    const panel = document.querySelector("[data-industry-panel]");
    if (!panel) return;

    const data = {
      Banking: {
        title: "Examiner risk lives in every KYC review and AML flag.",
        body: "Every KYC review, AML flag, and BSA report carries examiner risk, and most AI was not built for that scrutiny. Abacus deploys on-premise, keeps data inside your walls, and logs every decision for audit.",
        cta: "See How Banks Use Abacus",
        glyph: "BANK"
      },
      Insurance: {
        title: "Underwriting and claims AI that regulators can audit.",
        body: "Claims adjudication, underwriting, and fraud detection demand decisions you can defend. Abacus validates every output against your policies and keeps an immutable trail for every review.",
        cta: "See How Insurers Use Abacus",
        glyph: "INS"
      },
      Healthcare: {
        title: "PHI never leaves your walls. HIPAA-ready on day one.",
        body: "Patient records, clinical notes, and prior-auth workflows carry HIPAA exposure most AI ignores. Abacus is air-gapped and on-premise, with audit logging on every interaction.",
        cta: "See How Health Systems Use Abacus",
        glyph: "HEALTH"
      },
      "Credit Unions": {
        title: "NCUA-ready AI built for member-owned institutions.",
        body: "Member service, lending, and BSA monitoring run on the same secure infrastructure the largest banks trust, without usage-based surprises.",
        cta: "See How Credit Unions Use Abacus",
        glyph: "CU"
      },
      "Professional Services": {
        title: "Privileged client data stays privileged.",
        body: "Legal, accounting, and advisory work runs on confidential information. Abacus keeps every document and query inside your network with role-based access.",
        cta: "See How Firms Use Abacus",
        glyph: "PRO"
      }
    };

    const title = panel.querySelector("[data-industry-title]");
    const body = panel.querySelector("[data-industry-body]");
    const cta = panel.querySelector("[data-industry-cta]");
    const glyph = panel.querySelector("[data-industry-glyph]");

    document.querySelectorAll("[data-industry-tab]").forEach((tab) => {
      if (tab.dataset.abacusTabBound === "true") return;
      tab.dataset.abacusTabBound = "true";

      tab.addEventListener("click", () => {
        const next = data[tab.dataset.industryTab];
        if (!next) return;

        document.querySelectorAll("[data-industry-tab]").forEach((item) => item.classList.remove("is-active"));
        tab.classList.add("is-active");

        const update = () => {
          title.textContent = next.title;
          body.textContent = next.body;
          cta.textContent = next.cta + " →";
          glyph.textContent = next.glyph;
        };

        if (!window.gsap) {
          update();
          return;
        }

        gsap.to([title, body, cta, glyph], {
          autoAlpha: 0,
          y: 16,
          duration: 0.18,
          ease: "power2.out",
          onComplete: () => {
            update();
            gsap.fromTo([title, body, cta, glyph], { autoAlpha: 0, y: 16 }, {
              autoAlpha: 1,
              y: 0,
              duration: 0.42,
              stagger: 0.045,
              ease: "power3.out"
            });
          }
        });
      });
    });
  }

  function setupGSAP() {
    if (!window.gsap) return;
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    gsap.defaults({ ease: "power3.out", duration: 0.72 });

    if (window.ScrollTrigger) {
      gsap.registerPlugin(ScrollTrigger);
    }

    if (!reduceMotion) {
      document.querySelectorAll(".ab-hero:not([data-abacus-animated])").forEach((hero) => {
        hero.dataset.abacusAnimated = "true";
        const heroTl = gsap.timeline();
        heroTl
          .from(hero.closest("[data-section]")?.previousElementSibling?.matches(".ab-nav") ? hero.closest("[data-section]").previousElementSibling : ".ab-nav", { y: -18, autoAlpha: 0, duration: 0.55 })
          .from(hero.querySelectorAll(".ab-badge"), { y: 16, autoAlpha: 0, stagger: 0.06 }, "-=.18")
          .from(hero.querySelectorAll(".ab-hero-title > span"), { yPercent: 34, autoAlpha: 0, stagger: 0.09 }, "-=.2")
          .from(hero.querySelectorAll(".ab-hero-copy, .ab-hero-actions"), { y: 22, autoAlpha: 0, stagger: 0.08 }, "-=.25");
      });

      document.querySelectorAll(".ab-phrase:not([data-abacus-animated])").forEach((phrase) => {
        phrase.dataset.abacusAnimated = "true";
        gsap.to(phrase, {
          keyframes: [
            { rotationX: -7, y: -2, duration: 0.9 },
            { rotationX: 0, y: 0, duration: 0.9 }
          ],
          transformOrigin: "50% 70%",
          repeat: -1,
          repeatDelay: 1.15
        });
      });

      document.querySelectorAll(".ab-marquee-track:not([data-abacus-animated])").forEach((track) => {
        track.dataset.abacusAnimated = "true";
        gsap.to(track, {
          xPercent: -50,
          repeat: -1,
          duration: 28,
          ease: "none"
        });
      });
    }

    if (!window.ScrollTrigger || reduceMotion) return;

    const revealItems = gsap.utils.toArray(".ab-reveal:not([data-abacus-scroll])");
    revealItems.forEach((el) => { el.dataset.abacusScroll = "true"; });
    if (revealItems.length) {
      ScrollTrigger.batch(revealItems, {
        start: "top 82%",
        once: true,
        onEnter: (batch) => gsap.fromTo(batch, { autoAlpha: 0, y: 34 }, {
          autoAlpha: 1,
          y: 0,
          stagger: 0.08,
          overwrite: true
        })
      });
    }

    const revealCards = gsap.utils.toArray(".ab-reveal-card:not([data-abacus-scroll])");
    revealCards.forEach((el) => { el.dataset.abacusScroll = "true"; });
    if (revealCards.length) {
      ScrollTrigger.batch(revealCards, {
        start: "top 84%",
        once: true,
        onEnter: (batch) => gsap.fromTo(batch, { autoAlpha: 0, y: 42, scale: 0.985 }, {
          autoAlpha: 1,
          y: 0,
          scale: 1,
          stagger: 0.08,
          overwrite: true
        })
      });
    }

    document.querySelectorAll("[data-count]:not([data-abacus-count])").forEach((el) => {
      el.dataset.abacusCount = "true";
      const value = Number(el.dataset.count);
      const suffix = el.dataset.suffix || "";
      const prefix = el.dataset.prefix || "";
      const decimals = Number(el.dataset.decimals || 0);
      const obj = { n: 0 };

      gsap.to(obj, {
        n: value,
        duration: 1.4,
        ease: "power2.out",
        scrollTrigger: { trigger: el, start: "top 84%", once: true },
        onUpdate: () => {
          el.textContent = prefix + obj.n.toLocaleString("en-US", {
            maximumFractionDigits: decimals,
            minimumFractionDigits: decimals
          }) + suffix;
        }
      });
    });

    document.querySelectorAll(".ab-product-media:not([data-abacus-scroll])").forEach((media) => {
      media.dataset.abacusScroll = "true";
      const feature = media.closest(".ab-product-feature");
      if (!feature) return;

      gsap.to(media, {
        backgroundPosition: "58% center",
        scrollTrigger: {
          trigger: feature,
          start: "top bottom",
          end: "bottom top",
          scrub: 1
        }
      });
    });

    ScrollTrigger.refresh();
  }

  function init() {
    applyPreviewMode();
    setupTabs();
    waitForGSAP();
  }

  function waitForGSAP(attempt = 0) {
    if (window.gsap) {
      setupGSAP();
      return;
    }
    if (attempt > 40) return;
    window.setTimeout(() => waitForGSAP(attempt + 1), 100);
  }

  window.AbacusAnimations = { init };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:reorder", init);
  document.addEventListener("shopify:block:select", init);
})();
